"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
const react_1 = require("react");
const AuthContext = (0, react_1.createContext)({
    user: null,
    isAuthenticated: null,
    checkAuthentication: () => Promise.resolve(false),
    setUser: (user) => { },
    signIn: (email, password, remember) => Promise.resolve({}),
    signOut: () => { },
});
exports.default = AuthContext;
const useAuth = () => {
    const context = (0, react_1.useContext)(AuthContext);
    if (context === undefined) {
        throw new Error(`useAuth must be used within a AuthContext.Provider`);
    }
    return context;
};
exports.useAuth = useAuth;
